import {Injectable} from '@angular/core';
import {NestApiProvider} from '../nest-api';
import {Observable} from 'rxjs';
import {ResponsePaging} from '../nest-responses';
import {RequestEpfSetting, ResponseGetEpfSetting} from './epf-setting.dto';

@Injectable()
export class EpfSettingApi {
  private readonly service: string = 'payroll';
  private readonly model: string = 'epf-setting';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public getepfsetting(): Observable<ResponsePaging<ResponseGetEpfSetting>> {
    const method: string = 'GET';
    const func: string = 'getepfsetting';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<ResponseGetEpfSetting>>(method, url, params, urlParams, body);
  }

  public epfsetting(payload: RequestEpfSetting[]): Observable<any> {
    const method: string = 'POST';
    const func: string = 'epfsetting';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/epf-setting.api.ts